module.exports = __webpack_public_path__ + "static/media/oval-connected.44bbab6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/oval-connected.svg
// module id = 848
// module chunks = 21